module.exports = __webpack_public_path__ + "static/media/burnerwallet.f636a291.png";